import proxybase from './proxybase';

class UtilitiesService {
  getList(category) {
    return proxybase
      .get(`/utilities/getList/${category || ''}`)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  updateListItem(body) {
    return proxybase
      .post(`/utilities/updateListItem`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
const UtilitiesServiceInstance = new UtilitiesService();
export default UtilitiesServiceInstance;
